(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/mini-betslip/assets/javascripts/mini-betslip.js') >= 0) return;  svs.modules.push('/components/lb-ui/mini-betslip/assets/javascripts/mini-betslip.js');
"use strict";

const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIcon = _svs$ui.ReactIcon;
const Loader = svs.components.ReactLoader.Loader;
const format = svs.utils.format;
const MiniBetslip = _ref => {
  let errorMessage = _ref.errorMessage,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    isSelfService = _ref.isSelfService,
    onAbort = _ref.onAbort,
    onNewCoupon = _ref.onNewCoupon,
    onPay = _ref.onPay,
    price = _ref.price;
  let payButtonLabel;
  if (errorMessage) {
    payButtonLabel = 'ERROR';
  } else if (isSelfService) {
    payButtonLabel = 'Lägg till';
  } else {
    payButtonLabel = "Betala ".concat(price > 0 ? format.Currency(price) : '-', " kr");
  }
  const isPayable = isValid && !errorMessage && !isLoading;
  const payButton = React.createElement(ReactButton, {
    className: "mini-betslip-payment-btn mini-betslip-btn f-center",
    disabled: !isPayable,
    focus: true,
    onClick: onPay,
    size: 300
  }, isLoading && React.createElement(Loader, {
    inverted: true,
    size: 200
  }), !isLoading && payButtonLabel);
  const newCouponButton = onNewCoupon ? React.createElement(ReactButton, {
    className: "mini-betslip-newcoupon-btn mini-betslip-btn",
    onClick: onNewCoupon,
    size: 300,
    transparent: true
  }, React.createElement(ReactIcon, {
    icon: "refresh",
    size: "300"
  })) : null;
  const abortButton = onAbort ? React.createElement(ReactButton, {
    className: "mini-betslip-abort-btn mini-betslip-btn",
    onClick: onAbort,
    size: 300,
    transparent: true
  }, "Avbryt") : null;
  return React.createElement("div", {
    className: "mini-betslip"
  }, errorMessage ? React.createElement("div", {
    className: "mini-betslip-row mini-betslip-error align-center"
  }, React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "200"
  }), React.createElement("div", {
    className: "fc-red f-left"
  }, errorMessage)) : null, React.createElement("div", {
    className: "mini-betslip-row"
  }, !onAbort && onNewCoupon && newCouponButton, payButton), onAbort && React.createElement("div", {
    className: "mini-betslip-row"
  }, abortButton, onNewCoupon && newCouponButton));
};
setGlobal('svs.components.lbUi.miniBetslip.basic', MiniBetslip);

 })(window);